














import Enumerable from "linq";
import Moment from "moment";
import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { Patient } from "../../../../../../domain/patient";
import { DateDuration } from "../../../../../../domain/system";
import { Department } from "../../../../../../domain/department";
import { IOcojoImageSource } from "../../../../../../domain/ocojo";
import { DomainRegistry } from "../../../../../../domain";
import { ModelEditableMixin } from "../../../../../system/mixins";
import { StandardOption } from "../../../../../system/selectors/mixins";
import OptionDropDownSelector from "../../../../../system/selectors/OptionDropDownSelector.vue";

@Component({
  components: {
    OptionDropDownSelector,
  }
})
export default class OcojoImageFinder extends Mixins(ModelEditableMixin) {
  @Prop()
  patient: Patient;

  @Prop()
  isFinding: boolean;

  @Emit("update:isFinding")
  updateIsFinding(value: boolean) {}

  get ocojoName(): string {
    return this.$configuration.behavior.collaboration.ocojo.imageName;
  }
  
  get isFindingAccessor(): boolean {
    return this.isFinding;
  }

  set isFindingAccessor(value: boolean) {
    this.updateIsFinding(value);
  }

  editingSource: IOcojoImageSource[];
  departments: Department[];

  data(): any {
    return {
      imageSource: [],
      selectedSource: null as IOcojoImageSource,
    };
  }
  imageSource: IOcojoImageSource[];
  selectedSource: IOcojoImageSource;

  async mounted() {
    await this.loadDepartment();
    this.loadOcojoImages();
  }

  async loadDepartment() {
    this.departments = [];
    const repository = DomainRegistry.department.getDepartmentRepository();
    await repository.getAllEntities()
      .then(e => this.departments = e)
      .catch(e => {
        this.$error(
          this.$wording.common.department + "情報取得失敗",
          this.$wording.common.department + "情報を取得できませんでした。",
          e,
        );
      });
  }

  loadOcojoImages() {
    this.isFindingAccessor = true;
    this.selectedSource = null;
    this.imageSource = [];
    this.editingSource = [];
    const repository = DomainRegistry.ocojo.getOcojoRepository();

    repository.getPatientRelatedOcojoImages(this.patient.id, new DateDuration(null, null), null, null)
      .then(e => {
        this.imageSource = e;
        this.editingSource = e;
        this.isFindingAccessor = false;
      })
      .catch(e => {
        this.isFindingAccessor = false;
        this.$error(
          this.ocojoName + "検索失敗",
          this.ocojoName + "検索失敗しました。",
          e,
        );
      });
  }

  get dropDownOptions(): StandardOption<IOcojoImageSource>[] {
    return Enumerable.from([ new StandardOption<IOcojoImageSource>("未指定", null) ])
      .concat(this.imageSourceOptions)
      .toArray();
  }

  get imageSourceOptions(): StandardOption<IOcojoImageSource>[] {
    return Enumerable.from(this.imageSource)
      .distinct(s => s.imageDate.toDateString() + s.departmentId)
      .select(s => new StandardOption<IOcojoImageSource>(Moment(s.imageDate).format("YYYY/MM/DD") + " " + this.getDepartmentName(s.departmentId), s))
      .toArray();
  }

  getDepartmentName(departmentId: string): string {
    const department = Enumerable.from(this.departments)
      .firstOrDefault(d => d.id === departmentId);
    return department ? department.name : "";
  }

  @Watch("selectedSource")
  onSelectedSourceUpdated(newValue: IOcojoImageSource, oldValue: IOcojoImageSource) {
    this.editingSource = newValue !== null
      ? Enumerable.from(this.imageSource)
        .where(s => s.imageDate.toDateString() === newValue.imageDate.toDateString() && s.departmentId === newValue.departmentId)
        .toArray()
      : this.imageSource;
  }
}
